class NewSearchPage extends HTMLElement {
  constructor() {
    super();

    this.query = this.getAttribute("data-q");
    this.currency = this.getAttribute("data-shop-currency");
    this.resultsWrapper = this.querySelector(".new-search-page-results");
    this.filtersWrapper = this.querySelector(".new-search-page-filters");
    this.count = this.querySelector(".new-search-page-count");
    this.filterButton = this.querySelector(".new-search-page-filter-btn");
    this.filterOverlay = this.querySelector(".new-search-page-filters-overlay");
    this.filter = this.querySelector(".new-search-page-filters");
    this.sort = this.querySelector(".new-search-page-sort-select");
    this.loadmore = this.querySelector(".new-search-page-load-more-btn");

    this.init();
  }

  init() {

    this.executeUnifiedStorefrontSearch(this.query);

    this.sort.addEventListener("change", (e) => {
      let groups = [];
      e.target
        .closest(".new-search-page")
        .querySelectorAll(".new-search-page-filters-item")
        .forEach((item) => {
          let checkedInputs = item.querySelectorAll(".new-search-page-filters-input:checked");
          if (checkedInputs.length === 0) return;
          let parts = [];
          checkedInputs.forEach((input) => {
            parts.push(`${input.getAttribute("data-name")}:=${input.value}`);
          });
          groups.push(parts.join(" || "));
        });
      let filterQuery = groups.join(" && ");
      this.resultsWrapper.innerHTML = '';
      let sortBy = e.currentTarget.value;
      this.executeUnifiedStorefrontSearch(this.query, filterQuery, false, sortBy);
    });

    this.loadmore.addEventListener("click", (e) => {
      e.currentTarget.classList.add("loading--search");
      let groups = [];
      e.target
        .closest(".new-search-page")
        .querySelectorAll(".new-search-page-filters-item")
        .forEach((item) => {
          let checkedInputs = item.querySelectorAll(".new-search-page-filters-input:checked");
          if (checkedInputs.length === 0) return;
          let parts = [];
          checkedInputs.forEach((input) => {
            parts.push(`${input.getAttribute("data-name")}:=${input.value}`);
          });
          groups.push(parts.join(" || "));
        });
      let filterQuery = groups.join(" && ");
      let sortBy = this.sort.value;
      let page = parseInt(e.currentTarget.getAttribute("data-page"));
      this.executeUnifiedStorefrontSearch(this.query, filterQuery, false, sortBy, page);
    });

    this.addEventListener("click", (e) => {
      let filterItem = e.target.closest(".new-search-page-filters-input");
      if (!filterItem) return;
      let groups = [];
      e.target
        .closest(".new-search-page-filters")
        .querySelectorAll(".new-search-page-filters-item")
        .forEach((item) => {
          let checkedInputs = item.querySelectorAll(".new-search-page-filters-input:checked");
          if (checkedInputs.length === 0) return;
          let parts = [];
          checkedInputs.forEach((input) => {
            parts.push(`${input.getAttribute("data-name")}:=${input.value}`);
          });
          groups.push(parts.join(" || "));
        });
      let filterQuery = groups.join(" && ");
      this.resultsWrapper.innerHTML = '';
      let sortBy = this.sort.value;
      this.executeUnifiedStorefrontSearch(this.query, filterQuery, false, sortBy);
    });

    this.addEventListener("click", (e) => {
      let filterItem = e.target.closest(".new-search-page-filters-close");
      if (!filterItem) return;
      this.filterOverlay.classList.remove("active");
      this.filter.classList.remove("active");
      document.body.classList.remove("overflow-hidden-megamenu");
    });

    this.filterButton.addEventListener("click", (e) => {
      this.filterOverlay.classList.add("active");
      this.filter.classList.add("active");
      document.body.classList.add("overflow-hidden-megamenu");
    })

    this.filterOverlay.addEventListener("click", (e) => {
      this.filterOverlay.classList.remove("active");
      this.filter.classList.remove("active");
      document.body.classList.remove("overflow-hidden-megamenu");
    })

  }

  executeUnifiedStorefrontSearch = async (val, filterBy='', updateFilters=true, sort="_text_match:desc", page=1) => {

    if(this.resultsWrapper){
      this.resultsWrapper.classList.add("searching");
    }

    const endpointUrl = "/apps/surge/multi_search";
    
    const combinedPayload = {
      "searches": [
        {
          "collection": `products`,
          "q": val,
          "query_by": "title,description,vendor,product_type,tags",
          "facet_by": "metafields.custom.category,metafields.custom.characteristics,metafields.ncr-middleware-app.brand",
          "filter_by": ["available:=true", filterBy].filter(Boolean).join(" && "), // every page, filter and sort keeps to in-stock products
          "sort_by": sort,
          "per_page": 15,
          "page": page
        },
        surgePetSearch(val, this.dataset.petTypes)
      ],
      "source": "search_page",
      "search_context": "instant_search"
    };

    try {
      const response = await fetch(endpointUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(combinedPayload)
      });
      const operationalMatrix = await response.json();
      const [productLookups, metaLookups] = operationalMatrix.results || [];



      if(productLookups?.facet_counts?.length > 0 && updateFilters == true){
        let filters = ``;
        for(let item of productLookups?.facet_counts){
          filters += this.renderFilters(item);
        }
        filters += `<button type="button" class="new-search-page-filters-close" aria-label="Close filters">&#10005;</button>`;
        if(this.filtersWrapper){
          this.filtersWrapper.innerHTML = filters;
        }
      }

      if(productLookups?.hits.length > 0 || metaLookups?.hits.length > 0){
        let cards = ``;
        const metaHits = !metaLookups?.error && page === 1 ? metaLookups.hits : [];
        const productHits = !productLookups?.error ? productLookups.hits : [];
        // Only re-rank by keyword match for "Relevance"; name/price sorts keep the order the user picked
        const results = sort === '_text_match:desc'
          ? rankSearchResults(val, metaHits, productHits)
          : [...metaHits.map(({ document }) => ({ type: 'meta', document })), ...productHits.map(({ document }) => ({ type: 'product', document }))];
        for(let item of results){
          cards += item.type === 'meta' ? this.renderMetaCard(item.document) : this.renderProductCard(item.document);
        }
        if(this.resultsWrapper){
          this.resultsWrapper.classList.remove("not-found");
          this.resultsWrapper.classList.remove("searching");
          this.resultsWrapper.classList.add("searched");
          this.resultsWrapper.insertAdjacentHTML('beforeend', cards);
          hydrateFpbBadges(this.resultsWrapper);
        }
        window.PlpCardLayout?.scheduleUpdate?.(this);
      }
      else{
        if(this.resultsWrapper){
          this.resultsWrapper.classList.remove("searching");
          this.resultsWrapper.classList.remove("searched");
          this.resultsWrapper.classList.add("not-found");
        }
      }

      // Pets only come with page 1, so "load more" and the total follow products; pets count as shown
      const shownCount = this.resultsWrapper.querySelectorAll(".new-search-page-result-item").length;
      const shownPets = this.resultsWrapper.querySelectorAll(".new-search-page-result-item .new-pet-card").length;
      const productTotal = productLookups?.found || 0;

      if(this.loadmore){
        this.loadmore.classList.remove("loading--search");
        this.loadmore.setAttribute("data-page", productLookups?.page + 1)
        this.loadmore.classList.toggle("active", shownCount - shownPets < productTotal);
      }

      if(this.count){
        this.count.textContent = `Showing ${shownCount} of ${productTotal + shownPets} Items`;
      }

    } catch (err) {
      console.error("Unified network pipeline error:", err);
      if (this.resultsWrapper) {
        this.resultsWrapper.classList.add('not-found');
        this.resultsWrapper.classList.remove('searching');
        this.resultsWrapper.classList.remove('searched');
      }
    }
  }

  renderFilters(item){
    return `
      <details class="new-search-page-filters-item" ${item.counts.length > 0 ? 'open' : ''}>
        <summary class="new-search-page-filters-title">${item.field_name.includes('metafields') ? item.field_name.split('.')[item.field_name.split('.').length - 1] : item.field_name}
          <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 7L7 1L13 7" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </summary>
        <div class="new-search-page-filters-content">
          ${item.counts.length > 0 ? this.renderFilterItems(item.counts, item.field_name) : ''}
        </div>
      </details>
    `;
  }

  renderFilterItems(item, name){
    let filterItems = ``;
    let count = 0;
    for(let filter of item){
      count++;
      const value = escapeHTML(filter.value);
      const id = `new-search-filter-${count}-${escapeHTML(filter.value.replaceAll(' ', '-').toLowerCase())}`;
      filterItems += `
        <input id="${id}" type="checkbox" class="new-search-page-filters-input" data-name="${name}" value="${value}" />
        <label for="${id}" class="new-search-page-filters-label">
          <span>
            <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5L3.7 8L10 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          ${value}
        </label>
      `;
    }
    return filterItems;
  }

  renderMetaCard(meta){
    return `<div class="new-search-page-result-item">${renderSearchPetCard(meta)}</div>`;
  }


  renderProductCard(product){
    return `<div class="new-search-page-result-item">${renderSearchProductCard(product, this.currency)}</div>`;
  }



}
customElements.define('new-search-page', NewSearchPage);